import { ReactNode } from 'react'
import { Button } from '@tovala/component-library'
import ConfirmationDialog, {
  ConfirmationBody,
  ConfirmationButtons,
  ConfirmationHeader,
} from 'components/common/ConfirmationDialog'

const ReleaseFromCartConfirmation = ({
  children,
  onClickClose,
  onClickConfirm,
}: {
  children: ReactNode
  onClickClose(): void
  onClickConfirm(): void
}) => {
  return (
    <ConfirmationDialog onRequestClose={onClickClose}>
      <ConfirmationHeader heading="Release from cart?" />
      <ConfirmationBody>
        <div className="py-16 md:py-12">
          <div className="mx-auto max-w-sm text-body-lg">{children}</div>
        </div>
      </ConfirmationBody>
      <ConfirmationButtons>
        <div className="grid grid-cols-2 gap-2">
          <Button buttonStyle="stroke" onClick={onClickClose} size="large">
            Cancel
          </Button>

          <Button onClick={onClickConfirm} size="large">
            OK
          </Button>
        </div>
      </ConfirmationButtons>
    </ConfirmationDialog>
  )
}

export default ReleaseFromCartConfirmation
